'use strict'

import Vue from 'vue'
import axios from 'axios'
import store from './store'
import router from './router'
import * as mutation from "./mutation-types";
// import Qs from "qs"

const vm = new Vue()
const baseUrl = ""

axios.interceptors.request.use(
    (config) => {
        return config
    },
    (error) => {
        // console.log(error)
        vm.$message.error(i18n.t("api.requestError"))
    }
)


axios.interceptors.response.use(
    (res) => {
        // console.log("axios.interceptors.response")
        // console.log(res)
        if (res.data.success) {
            return res.data
        }
    },
    (error) => {
        // console.log(error)
        vm.$message.error(i18n.t("api.requestError"))
        return Promise.reject(error)
    }
)
export const getData = (url, params) => {
    url = url.path || url
    return axios({
        method:"get",
        url: baseUrl + url,
        params: params,
    })
}
export const postData = (url, params) => {
    url = url.path || url
    // console.log("baseUrl+url is " + baseUrl + url)
    // console.log("params " + JSON.stringify(params))
    return axios({
        method:"post",
        url: baseUrl + url,
        headers: {
            'Content-Type': 'application/json',
        },
        data: params,
    })
}
